// extracted by mini-css-extract-plugin
export default {"segmentedChoise":"CustomSegmented_segmentedChoise__aZ3jF"};